import React, { ReactNode, useEffect } from 'react';
import { banner, formlogo, Customer_Banner } from '../../assets/images/index';
import SocialLogin from '../../components/auth/sociallogin';
import { useLocation } from 'react-router';

interface NonAuthLayoutProps {
  children: ReactNode;
  social_login_text?: string;
  path?: string;
}

const NonAuthLayout: React.FC<NonAuthLayoutProps> = ({
  children,
  social_login_text,
  path,
}) => {
  return (
    <div className="auth_layout">
      <div className="auth_banner">
        <img
          src={Customer_Banner}
          className="max-height-image"
          alt="Full-size"
        />
      </div>
      <div className="auth_content">
        <div className="auth_logo">
          {path !== '/verification' && <img src={formlogo} alt="Logo" />}
        </div>
        <div className="form">{children}</div>
        <div className="auth_footer">
          {/* {social_login_text == 'reset-password' ? (
            <></>
          ) : (
            <SocialLogin page={social_login_text} />
          )} */}
          {/* {social_login_text == 'signup' && (
            <SocialLogin page={social_login_text} />
          )} */}
        </div>
      </div>
    </div>
  );
};

export default NonAuthLayout;
